
import pageHearder from "./common/Hearder.vue";
import LoginMsg from './common/Loginmsg.vue';
import Alert from 'vux/src/components/alert/index.vue'


export default {
name: "MainDetail",
props: [],
components: {
pageHearder,
LoginMsg,
Alert
},

data() {
return {
selected: "sycm",
serverImg: "https://static.diantoushi.com/cnd/qrcode/dts-qr_003.png",
backTop: "https://static.diantoushi.com/images/20200424/backTop.png",
showService: false,
funcList: [
{
title: "生意参谋指数还原",
key: "sycm",
videoList: [
{
title: "一键还原指数",
desc: "一秒批量转化真实数据 自动计算高阶指数",
imgUrl: "https://static.diantoushi.com/images/20200424/sycm.png",
videoUrl: "https://static.diantoushi.com/video/dts_0607_zs.mp4"
},
{
title: "同类任意竞品透视",
desc: "可查看参谋同类任意宝贝的核心指标",
imgUrl: "https://static.diantoushi.com/images/20200424/dts20200423_1.png",
videoUrl: "https://static.diantoushi.com/video/dts20200424_1.mp4"
},
{
title: "秒选蓝海词",
desc: "关键词优化 人群优化 地域优化 时间优化",
imgUrl: "https://static.diantoushi.com/images/20200424/dts20200423_2.png",
videoUrl: "https://static.diantoushi.com/video/dts20200424_2.mp4"
},
{
title: "标题优化",
desc: "买家秀 评论 主图/视频 详情页下载 推广渠道透视",
imgUrl: "https://static.diantoushi.com/images/20200424/btyh.png",
videoUrl: "https://static.diantoushi.com/video/dts_0107_2.mp4"
},
{
title: "爆款分析",
desc: "筛选同价格带的高流量、高交易、高意向的宝贝",
imgUrl: "https://static.diantoushi.com/images/20200424/dts20200423_9.png",
videoUrl: "https://static.diantoushi.com/video/dts20200424_3.mp4"
}
]
},
{
title: "直通车工具",
key: "ztc",
videoList: [
{
title: "关键词优化",
desc: "快速分析优质关键词，减少无效关键词消耗",
imgUrl: "https://static.diantoushi.com/images/20200424/dts20200423_14.png",
videoUrl: "https://static.diantoushi.com/video/dts20200425_2.mp4"
},
{
title: "人群优化",
desc: "一键快速添加人群，拒绝重复，避免遗漏",
imgUrl: "https://static.diantoushi.com/images/20200424/dts20200423_15.png",
videoUrl: "https://static.diantoushi.com/video/dts20200425_3.mp4"
},
{
title: "市级优化",
desc: "精准地域，减少无效支出",
imgUrl: "https://static.diantoushi.com/images/20200424/dts20200423_17.png",
videoUrl: "https://static.diantoushi.com/video/dts20200425_4.mp4"
},
{
title: "时间优化",
desc: "筛选指标优化投放时间，降低CPC",
imgUrl: "https://static.diantoushi.com/images/20200424/dts20200423_16.png",
videoUrl: "https://static.diantoushi.com/video/dts20200425_5.mp4"
},
{
title: "车图下载",
desc: "一键下载同行车图",
imgUrl: "https://static.diantoushi.com/images/20200424/dts20200423_18.png",
videoUrl: "https://static.diantoushi.com/video/dts20200425_6.mp4"
}
]
},
{
title: "宝贝详情页工具",
key: "bbxq",
videoList: [
{
title: "买家秀下载",
desc: "一键下载高清买家秀图片、视频",
imgUrl: "https://static.diantoushi.com/images/20200424/dts20200423_11.png",
videoUrl: "https://static.diantoushi.com/video/dts20200425_7.mp4"
},
{
title: "评论下载",
desc: "",
imgUrl: "https://static.diantoushi.com/images/20200424/dts20200423_12.png",
videoUrl: "https://static.diantoushi.com/video/dts20200425_8.mp4"
},
{
title: "主图/视频/SKU图下载",
desc: "",
imgUrl: "https://static.diantoushi.com/images/20200424/dts20200423_4.png",
videoUrl: "https://static.diantoushi.com/video/dts20200425_11.mp4"
},
{
title: "SKU分析",
desc: "分析评论里SKU购买占比",
imgUrl: "https://static.diantoushi.com/images/20200424/dts20200424_1.png",
videoUrl: "https://static.diantoushi.com/video/dts20200424_4.mp4"
},
{
title: "问大家下载",
desc: "分析竞品买家关心的问题，找出用户的痛点",
imgUrl: "https://static.diantoushi.com/images/20200424/dts20200423_5.png",
videoUrl: "https://static.diantoushi.com/video/dts20200424_5.mp4"
}
]
},
{
title: "店铺动态监控",
key: "dpdt",
videoList: [
{
title: "实时销量监控",
desc: "分时销量，分时趋势图显示",
imgUrl: "https://static.diantoushi.com/images/20200424/dts20200424_2.png",
videoUrl: "https://static.diantoushi.com/video/dts_0103_1.mp4"
},
{
title: "SKU销量监控",
desc: "宝贝SKU销量占比分析，30天SKU销量趋势",
imgUrl: "https://static.diantoushi.com/images/20200424/dts20200423_13.png",
videoUrl: "https://static.diantoushi.com/video/dts_1108_1.mp4"
},
{
title: "店铺上新监控",
desc: "透视宝贝上新时间、类目、售价、销量、收藏、加购等数据",
imgUrl: "https://static.diantoushi.com/images/20200424/dpsx.png",
videoUrl: "https://static.diantoushi.com/video/dts_0726_shop.mp4"
}
]
},
{
title: "京东商智数据还原",
key: "jdsz",
videoList: [
{
title: "覆盖行业和竞争",
desc: "",
imgUrl: "https://static.diantoushi.com/images/20200424/dts20200423_10.png",
videoUrl: "https://static.diantoushi.com/video/dts20200424_6.mp4"
},
{
title: "一键还原指数",
desc: "一键还原指标，快速精准",
imgUrl: "https://static.diantoushi.com/images/20200424/sycm.png",
videoUrl: "https://static.diantoushi.com/video/dts20200425_9.mp4"
},
{
title: "高阶指标自动计算",
desc: "自动结算高阶指标，如UV、客单价等",
imgUrl: "https://static.diantoushi.com/images/20200424/dts20200424_3.png",
videoUrl: "https://static.diantoushi.com/video/dts20200424_7.mp4"
},
{
title: "批量下载",
desc: "一键导出所有数据",
imgUrl: "https://static.diantoushi.com/images/20200424/dts20200423_19.png",
videoUrl: "https://static.diantoushi.com/video/dts20200425_10.mp4"
}
]
},
{
title: "京东详情页工具",
key: "jdxq",
videoList: [
{
title: "买家秀下载",
desc: "一键下载高清买家秀图片、视频",
imgUrl: "https://static.diantoushi.com/images/20200424/dts20200423_6.png",
videoUrl: "https://static.diantoushi.com/video/dts20200424_8.mp4"
},
{
title: "主图/视频/SKU图下载",
desc: "",
imgUrl: "https://static.diantoushi.com/images/20200424/dts20200423_7.png",
videoUrl: "https://static.diantoushi.com/video/dts20200424_9.mp4"
},
{
title: "评论下载",
desc: "",
imgUrl: "https://static.diantoushi.com/images/20200424/dts20200424_4.png",
videoUrl: "https://static.diantoushi.com/video/dts20200424_10.mp4"
},
{
title: "详情页下载",
desc: "",
imgUrl: "https://static.diantoushi.com/images/20200424/dts20200423_8.png",
videoUrl: "https://static.diantoushi.com/video/dts20200424_11.mp4"
}
]
}
]
};
},

methods: {
goPage: function (url) {
this.$router.push(url);
},
changeSelected: function() {
let { funcItem, idx } = this.$route.params;
if (funcItem) {
this.selected = funcItem.key;
}

let dom = document.getElementsByClassName("navbar-outer")[0];
if (idx && idx > 3) {
dom.scrollLeft = 300;
}
if (idx && idx > 6) {
dom.scrollLeft = 600;
}
},
handlePlayVideo: function(item, index, key) {
if (item.videoUrl) {
let video = document.getElementById("video" + index + key);
video.src = item.videoUrl;
video.play();
} else {
let gifShadow = document.getElementById("gif-shadow");
let gifImg = document.getElementById("gif-img");
gifShadow.style.display = "flex";
gifImg.src = item.gifUrl;
}
},
handleCloseVideo: function() {
let gifShadow = document.getElementById("gif-shadow");
gifShadow.style.display = "none";
},
handleShowService: function() {
this.showService = true;
},
scrollFunction: function() {
let backTopDom = document.getElementById("backTop");
if (backTopDom) {
if (
document.body.scrollTop > 20 ||
document.documentElement.scrollTop > 20
) {
backTopDom.style.display = "block";
} else {
backTopDom.style.display = "none";
}
}
},

handleToTop: function() {
window.scrollTo({
top: 0,
behavior: "smooth"
});
},
init: function() {
let that = this;







window.onscroll = function() {
that.scrollFunction();
};
}
},

mounted() {
this.changeSelected();
this.init();
this.handleToTop();
}
};
